import $api from "@/frontend/shared/api/axios";

export async function patchUpdateDetails({ id, domain }: { id: number; domain: string }) {
  const response = await $api.patch(`/portfolio-companies/${id}/company-details`, { website: domain });
  return response;
}
